import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusShowtimesEditor from 'components/editor/movies/showtimes/showtimesFocus';
import UniversalShowtimesEditor from 'components/editor/movies/showtimes/showtimesUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusShowtimesEditor {...props} />;
	return <UniversalShowtimesEditor {...props} />;
};